/** Agent-spine (ADR-003): one unit of agent/pipeline work, the FK activity contract. */
export const activityDescriptor = {
    slug: 'activity',
    kind: 'document',
    label: { singular: 'Attività', plural: 'Attività' },
    table: 'ai_portal_activity',
    idStrategy: 'sha256',
    fields: [
        { name: 'activity_id', type: 'text', label: 'ID attività', required: true, unique: true },
        { name: 'pipeline', type: 'text', label: 'Pipeline', required: true },
        { name: 'title', type: 'text', label: 'Titolo', required: true },
        { name: 'status', type: 'text', label: 'Stato' },
        { name: 'agent', type: 'text', label: 'Agente', required: true },
        { name: 'context', type: 'json', label: 'Contesto' },
        { name: 'target_ref', type: 'text', label: 'Riferimento destinatario' },
        { name: 'journey_execution_id', type: 'text', label: 'Esecuzione percorso' },
        { name: 'started_at', type: 'datetime', label: 'Avviata il', required: true },
        { name: 'completed_at', type: 'datetime', label: 'Completata il' },
    ],
    behaviors: {
        audit: true,
        tenantScoped: true,
    },
    emits: ['activity.pushed'],
    ui: { mode: 'generated', icon: 'ThunderboltOutlined', navGroup: 'Agenti', navOrder: 42 },
};
